import { AxiosInstance } from 'axios';
import { SpotBillingRepository } from '@/model/repository/spot-billing/SpotBillingRepository';

export default (Repository: AxiosInstance) => (): SpotBillingRepository => ({
  async facilityAvailable({ facilityId }) {
    try {
      const response = await Repository.get(`/spot-billing-api/admin/facilities/${facilityId}/available`);
      return response.status === 204;
    } catch (error) {
      return false;
    }
  },

  async fetchMeAvailable() {
    try {
      const response = await Repository.get(`/spot-billing-api/admin/me/available`);
      return response.status === 204;
    } catch (error) {
      return false;
    }
  }
});
